import { Type } from "@angular/core";
import { ResultGridComponent } from './result-grid.component';
import { ResultBarChartComponent } from './result-bar-chart.component';
import { ResultTipComponent } from './result-tip.component';

export * from './result-tip.component';
export * from "./result-grid.component";
export * from './result-bar-chart.component';

export const VULNERABILITY_DIRECTIVES: Type<any>[] = [
    ResultGridComponent,
    ResultTipComponent,
    ResultBarChartComponent
];
